<template>
  <p v-if="getSelectedElements.length == 0" class="text-primary">Click an element in the viewer.</p>
  <Panel class="panel w-full" :header="selectedText" v-if="getSelectedElements.length > 0">
    <DataTable :value="panelProperties" class="p-datatable-sm" :scrollable="true" scrollHeight="flex" :resizableColumns="true" columnResizeMode="fit">
      <template #empty>
        Properties not available
      </template>
      <Column header="Property" field="property"  style="width: 50%;"></Column>
      <Column header="Value" field="value"  style="width: 50%;">
        <template #body="slotProps">
          <div class="w-full" v-if="isImage(slotProps.data.value)">
            <img style="width: 100%;" :src="slotProps.data.value">
          </div>
          <div class="w-full flex" v-else-if="editingProperty == slotProps.data.property">
            <InputText autofocus class="flex-1 w-full editing-property-input" v-model="editingPropertyValue" @keydown.enter="loseFocus" @blur="changePropertyInput(editingPropertyValue, slotProps.data.property)"/> 
          </div>
          <div class="w-full flex align-items-center" v-else @click="startEditingProperty(slotProps)">
            <td class="cell flex-1" v-if="slotProps.data.varies">&lt;varies&gt;</td>
            <td class="cell flex-1" style="min-height: 20px" v-else>{{ slotProps.data.value }}</td>
          </div>
        </template>
      </Column>
    </DataTable>
  </Panel>
</template>

<script>

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Panel from 'primevue/panel';
import InputText from 'primevue/inputtext';
import { mapActions, mapGetters } from 'vuex'

export default {
  components: { DataTable, Column, Panel, InputText },

  props: ["tab"],

  computed: {
    ...mapGetters("general", ["getSelectedElements"]),
    ...mapGetters("settings", ["getSelectionMode"],),

    selectedText() {
      return this.getSelectedElements.map(x => x.ID).join(', ');
    },

    panelProperties() {
      const properties = {};
      this.getSelectedElements.forEach(el => {
        const availableKeys = this.getKeys(el);
        availableKeys.forEach(key => {
          if (properties[key] === undefined) {
            properties[key] = new Set();
          }
          properties[key].add(el[key]);
        });
      });

      return Object.keys(properties).map(key => {
        return { property: key, value: Array.from(properties[key]).join(', '), varies: properties[key].size > 1 };
      }).sort((a, b) => {
        if (a.property < b.property) return -1;
        if (a.property > b.property) return 1;
        return 0;
      });
    },
  },

  methods: {
    ...mapActions('general', ["changeSelected", "updateProperty"]),

    getKeys(el) {
      if (this.tab) {
        return Object.keys(el).filter(x => !this.blacklistedKeys.includes(x) && this.tab.properties.includes(x));
      }
      else {
        return Object.keys(el).filter(x => !this.blacklistedKeys.includes(x));
      }
    },

    changePropertyInput(value, key) {
      console.log(value, key);
      this.getSelectedElements.forEach(el => {
        if (el[key] !== value) {
          this.updateProperty({ id: el.ID, key, value });
        }
      })
      // const dataID = id;
      // this.updateProperty({ id: dataID, key, value });
      this.editingProperty = null;
      this.editingPropertyValue = null;
    },

    loseFocus() {
      this.editingProperty = null;
    },

    getProperties(el) {
      const properties = this.getKeys(el).map((x) => { return { property: x, value: el[x]}});
      properties.sort((a, b) => {
        if (a.property < b.property) return -1;
        if (a.property > b.property) return 1;
        return 0;
      });
      return properties;
    },

    isImage(text) {
      let regex = /(http)?s?:?(\/\/[^"']*\.(?:png|jpg|jpeg|gif|png|svg))/;
      return (""+text).match(regex);
    },

    startEditingProperty(slotProps) {
      this.editingProperty = slotProps.data.property;
      this.editingPropertyValue = slotProps.data.value;
      if (slotProps.data.varies) {
        this.editingPropertyValue = '';
      }
      this.$nextTick(() => {
        document.querySelector('input.editing-property-input')?.focus();
        document.querySelector('input.editing-property-input')?.select();
      });
    }
  },
  data() {
    return {
      blacklistedKeys: ["Pbi2DGeometry","Pbi3DGeometry", "geometry", "TempPbi2DGeometry", "initialPosition"],
      editingProperty: null,
      editingPropertyValue: null,
    }
  },
  mounted() {
    this.selectedMode = this.getSelectionMode;
  }
  }
</script>

<style>
.panel .p-panel-content {
  padding: 0 !important;
}
.p-button.p-highlight {
  background: var(--primary-color) !important;
}
.p-datatable-sm td {
  width: 50%;
  white-space: normal;
}
</style>
<style scoped>
.p-datatable {
  width: 100%;
}
.cell {
  white-space: break-spaces;
  word-break: break-word;
}
.editing-property-input {
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  background: transparent !important;
  background: #262d37 !important;
  min-height: 22px;
}
</style>